<mapfre-header></mapfre-header>
<div class="container mapfre-content">
  <router-outlet></router-outlet>
</div>
